import Vue from 'vue';
export default {
  data() {
    return {
      searchTitle: '',
      searchModal: false,
      isSearch: false,
      searchFromDate: '',
      searchToDate: '',
      searchDiagnosis: null,
      searchCityId: null,
      searchResultId: null,
      searchTagId: null,
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
      isHeatMapLayer: true,
      headers: [
        {
          text: 'تاریخ',
          value: 'creationDate',
        },
        {
          text: 'عرض جغرافیایی(latitude)',
          value: 'latitude',
        },
        {
          text: 'طول جغرافیایی(longitude)',
          value: 'longitude',
        },
      ],
    };
  },
  methods: {
    makeDataReady: function (data) {
      this.latlngs = [];
      for (const item of data) {
        this.latlngs.push([item.latitude, item.longitude, 0.3]);
      }
    },
    setPreTimes: function () {
      this.tempSearchFromDate = '00:00:00 ';
      let temp = Vue.moment().format('jYYYY-jMM-jDD');
      this.tempSearchFromDate += temp;
      this.searchFromDate = Vue.moment().format('YYYY-MM-DD');
      this.searchFromDate += 'T00:00:00';
      this.searchToDate = Vue.moment().format('YYYY-MM-DDTHH:mm:ss');
      this.tempSearchToDate = Vue.moment().format('HH:mm:ss jYYYY-jMM-jDD');
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    toggleHeatMapLayer: function () {
      this.isHeatMapLayer = !this.isHeatMapLayer;
    },
    search: function () {
      this.searchModal = false;
      if (!this.searchFromDate) {
        this.setPreTimes();
      }
      this.getAmarHeatMapReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchDiagnosis,
        this.searchResultId,
        this.searchTagId,
        this.searchCityId,
      );
    },
    removeFilters: function () {
      this.searchDiagnosis = null;
      this.searchCityId = null;
      this.searchResultId = null;
      this.searchTagId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.isSearch = false;
      this.setPreTimes();
      this.getAmarHeatMapReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchDiagnosis,
        this.searchResultId,
        this.searchTagId,
        this.searchCityId,
      );
    },
    cancelSearch: function () {
      this.searchDiagnosis = null;
      this.searchCityId = null;
      this.searchResultId = null;
      this.searchTagId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.setPreTimes();
      this.searchModal = false;
    },
  },
  computed: {
    items: function () {
      return this.$store.state.reportModule.amarHeatMap;
    },
  },
};
